import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_OVERSEAS_EMERGENCY_MEDICAL_OR_DENTAL_EXPENSES,
  RESET_ACCIDENTAL_DEATH,
  RESET_CONTACT_EMERGENCY_ASSISTANCE,
  RESET_LOSS_OF_INCOME,
} from './constants';


// The initial state of the App
const initialState = fromJS({
  form: {
    areYouClaimingForOverseasEmergencyMedicalOrDentalExpenses: 'false',
    areYouClaimingForOverseas247: 'false',
    areYouClaimingForEmergencyMedicalAndHospitalExpenses: 'false',
    areYouClaimingForEmergencyDental: 'false',
    areYouClaimingForEmergencyEvacuation: 'false',
    areYouClaimingForHospitalCashPayment: 'false',
    areYouClaimingForAccidentalDeath: 'false',
    areYouClaimingForPermanentDisability: 'false',
    areYouClaimingForLossOfIncome: 'false',
    patientName: '',
    relationshipToYou: '',
    patientDateOfBirth: '',
    medicareNumber: '',
    whatIsYourInjuryOrIllness: '',
    didThisOccurWhilstEngagingInSnowSportActivity: 'false',
    wasTheInufredIllTravallerAnInpatient: 'false',
    dateOfAdmission: '',
    timeOfAdmission: null,
    dateOfDischarge: '',
    timeOfDischarge: null,
    contactEmergencyAssistance: 'false',
    assistanceCaseReferenceNumber: '',
    dateOfFirstMedicalConsultation: '',
    hasInjuredOrIllTravellerPreviously: 'false',
    medicalExpenses: [],
    awareOfAnyMedicalConditions: 'false',
    underInvestigation: 'false',
    haveMedicalConditionOrComplication: 'false',
    giveATerminalPrognosis: 'false',
    travellingAgainst: 'false',
    previousMedicalConditionDetails: '',
    plannedReturnToWorkDate: '',
    actualReturnToWorkDate: '',
    incomeLost: '',
    insuredName: '',
    insuredDateOfDeath: '',
    relationshipToYouAD: '',
    whatIsYourInjuryOrIllnessAD: '',
    didThisOccurWhilstEngagingInSnowSportActivityAD: 'false',
    wasTheInufredIllTravallerAnInpatientAD: 'false',
    dateOfAdmissionAD: '',
    timeOfAdmissionAD: null,
    dateOfDischargeAD: '',
    timeOfDischargeAD: null,
    nameOfPractitionerDentistHospitalAD: '',
    contactEmergencyAssistanceAD: 'false',
    assistanceCaseReferenceNumberAD: '',
    dateOfFirstMedicalConsultationAD: '',
    patientNameLI: '',
    relationshipToYouLI: '',
    patientDateOfBirthLI: '',
    medicareNumberLI: '',
    whatIsYourInjuryOrIllnessLI: '',
    didThisOccurWhilstEngagingInSnowSportActivityLI: 'false',
    wasTheInufredIllTravallerAnInpatientLI: 'false',
    dateOfAdmissionLI: '',
    timeOfAdmissionLI: null,
    dateOfDischargeLI: '',
    timeOfDischargeLI: null,
    nameOfPractitionerDentistHospitalLI: '',
    contactEmergencyAssistanceLI: 'false',
    assistanceCaseReferenceNumberLI: '',
    dateOfFirstMedicalConsultationLI: '',
  },
  errors: [],
});

const initialClaimingForOverseasEmergencyMedicalOrDentalExpenses = {
  form: {
    areYouClaimingForOverseasEmergencyMedicalOrDentalExpenses: 'false',
    patientName: '',
    relationshipToYou: '',
    patientDateOfBirth: '',
    medicareNumber: '',
    whatIsYourInjuryOrIllness: '',
    didThisOccurWhilstEngagingInSnowSportActivity: 'false',
    wasTheInufredIllTravallerAnInpatient: 'false',
    dateOfAdmission: '',
    timeOfAdmission: null,
    dateOfDischarge: '',
    timeOfDischarge: null,
    contactEmergencyAssistance: 'false',
    assistanceCaseReferenceNumber: '',
    dateOfFirstMedicalConsultation: '',
    hasInjuredOrIllTravellerPreviously: 'false',
    medicalExpenses: [],
    awareOfAnyMedicalConditions: 'false',
    underInvestigation: 'false',
    haveMedicalConditionOrComplication: 'false',
    giveATerminalPrognosis: 'false',
    travellingAgainst: 'false',
    previousMedicalConditionDetails: '',
  },
};

const initialClaimingForAccidentalDeath = {
  form: {
    areYouClaimingForAccidentalDeath: 'false',
    insuredName: '',
    relationshipToYouAD: '',
    insuredDateOfDeath: '',
    whatIsYourInjuryOrIllnessAD: '',
    didThisOccurWhilstEngagingInSnowSportActivityAD: 'false',
    wasTheInufredIllTravallerAnInpatientAD: 'false',
    dateOfAdmissionAD: '',
    timeOfAdmissionAD: null,
    dateOfDischargeAD: '',
    timeOfDischargeAD: null,
    nameOfPractitionerDentistHospitalAD: '',
    contactEmergencyAssistanceAD: 'false',
    assistanceCaseReferenceNumberAD: '',
    dateOfFirstMedicalConsultationAD: '',
  },
};

const initialClaimingForLossOfIncome = {
  form: {
    areYouClaimingForLossOfIncome: 'false',
    plannedReturnToWorkDate: '',
    actualReturnToWorkDate: '',
    incomeLost: '',
    patientNameLI: '',
    relationshipToYouLI: '',
    patientDateOfBirthLI: '',
    medicareNumberLI: '',
    whatIsYourInjuryOrIllnessLI: '',
    didThisOccurWhilstEngagingInSnowSportActivityLI: 'false',
    wasTheInufredIllTravallerAnInpatientLI: 'false',
    dateOfAdmissionLI: '',
    timeOfAdmissionLI: null,
    dateOfDischargeLI: '',
    timeOfDischargeLI: null,
    nameOfPractitionerDentistHospitalLI: '',
    contactEmergencyAssistanceLI: 'false',
    assistanceCaseReferenceNumberLI: '',
    dateOfFirstMedicalConsultationLI: '',
  },
};

const initialContactEmergencyAssistance = {
  form: {
    contactEmergencyAssistance: 'false',
    assistanceCaseReferenceNumber: '',
  },
};

const initialContactEmergencyAssistanceAD = {
  form: {
    contactEmergencyAssistanceAD: 'false',
    assistanceCaseReferenceNumberAD: '',
  },
};

const initialContactEmergencyAssistanceLI = {
  form: {
    contactEmergencyAssistanceLI: 'false',
    assistanceCaseReferenceNumberLI: '',
  },
};

const illTraveller = {
  form: {
    wasTheInufredIllTravallerAnInpatient: 'false',
    dateOfAdmission: '',
    timeOfAdmission: null,
    dateOfDischarge: '',
    timeOfDischarge: null,
  },
};

function stepOverseasMedicalReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED: {
      if (properties[1] === 'areYouClaimingForOverseasEmergencyMedicalOrDentalExpenses' && action.value === 'false') {
        return state.mergeDeep(initialClaimingForOverseasEmergencyMedicalOrDentalExpenses);
      }
      if (properties[1] === 'areYouClaimingForAccidentalDeath' && action.value === 'false') {
        return state.mergeDeep(initialClaimingForAccidentalDeath);
      }
      if (properties[1] === 'areYouClaimingForLossOfIncome' && action.value === 'false') {
        return state.mergeDeep(initialClaimingForLossOfIncome);
      }
      if (properties[1] === 'contactEmergencyAssistance' && action.value === 'false') {
        return state.mergeDeep(initialContactEmergencyAssistance);
      }
      if (properties[1] === 'contactEmergencyAssistanceLI' && action.value === 'false') {
        return state.mergeDeep(initialContactEmergencyAssistanceLI);
      }
      if (properties[1] === 'contactEmergencyAssistanceAD' && action.value === 'false') {
        return state.mergeDeep(initialContactEmergencyAssistanceAD);
      }
      if (properties[1] === 'wasTheInufredIllTravallerAnInpatient' && action.value === 'false') {
        return state.mergeDeep(illTraveller);
      }
      return state.setIn(properties, action.value);
    }
    case LOAD:
      return action.payload ? fromJS({ form: action.payload, errors: [] }) : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_OVERSEAS_EMERGENCY_MEDICAL_OR_DENTAL_EXPENSES:
      return state.mergeDeep(initialClaimingForOverseasEmergencyMedicalOrDentalExpenses);
    case RESET_ACCIDENTAL_DEATH:
      return state.mergeDeep(initialClaimingForAccidentalDeath);
    case RESET_LOSS_OF_INCOME:
      return state.mergeDeep(initialClaimingForLossOfIncome);
    case RESET_CONTACT_EMERGENCY_ASSISTANCE:
      return state.mergeDeep(initialContactEmergencyAssistance);
    default:
      return state;
  }
}

export default stepOverseasMedicalReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOverseasMedical/reducer.js